import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Box, Container, Card, CardContent, Typography, Button, alpha } from '@mui/material';
import { LoginHero } from '../../components/design-system';

const PendingApproval = () => {
  const [searchParams] = useSearchParams();
  const product = searchParams.get('product');

  return (
    <LoginHero>
      <Container maxWidth="sm">
        <Card sx={{
          p: 4,
          backdropFilter: 'blur(20px)',
          bgcolor: alpha('#ffffff', 0.95),
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
          border: `1px solid ${alpha('#ffffff', 0.2)}`
        }}>
          <CardContent>
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#0f172a', mb: 1 }}>
              Application Submitted
            </Typography>
            <Typography variant="body1" sx={{ color: '#475569', mb: 3 }}>
              Thank you for signing up. Your account is under review by our team. You will receive an email when your account is approved.
            </Typography>

            {product && (
              <Typography variant="body2" sx={{ color: '#64748b', mb: 3 }}>
                Selected product: {product.charAt(0).toUpperCase() + product.slice(1)}
              </Typography>
            )}

            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button component={Link} to="/login" variant="contained" sx={{ bgcolor: '#0d9488', '&:hover': { bgcolor: '#0f766e' } }}>
                Go to Login
              </Button>
              <Button component={Link} to="/" variant="text" sx={{ color: '#475569', '&:hover': { color: '#0d9488' } }}>
                Return Home
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </LoginHero>
  );
};

export default PendingApproval;

